import React from 'react';
import { navigate } from '@reach/router';
import { Typography } from '@material-ui/core';
import { useTranslation } from '../../../../../hooks/useTranslation';
import ROUTES from '../../../../../routes';
import Link from '../../../../text-link';

export const SignInBlock = () => {
  const { t } = useTranslation();

  const handleNavigation = async (route: string): Promise<void> => {
    await navigate(route, {
      state: { redirectUrl: ROUTES.OUTAGES },
    });
  };

  return (
    <>
      <Typography
        variant="body2"
        style={{ textAlign: 'center', fontWeight: 'bold' }}
      >
        <Link
          to={ROUTES.SIGN_IN}
          onClick={async e => {
            e.preventDefault();
            await handleNavigation(ROUTES.SIGN_IN);
          }}
        >
          {t('SIGN_IN')}
        </Link>{' '}
        {t('OR')}{' '}
        <Link
          to={ROUTES.REGISTRATION}
          onClick={async e => {
            e.preventDefault();
            await handleNavigation(ROUTES.REGISTRATION);
          }}
        >
          {t('REGISTER')}
        </Link>
      </Typography>
      <Typography
        variant="body2"
        style={{ textAlign: 'center', fontWeight: 'bold' }}
      >
        {t('FOR_ACCOUNT_STATUS_DETAILS_AND_ADVANCED_MAP_FUNCTIONALITY')}.
      </Typography>
    </>
  );
};

export default SignInBlock;
